var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4715_8704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02947 4.02947 0 9 0C13.9705 0 18 4.02947 18 9L9 9.78261L0 9Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20435 13.4998C2.76054 16.1899 5.6688 17.9999 9.00003 17.9999C12.3313 17.9999 15.2395 16.1899 16.7957 13.4998L9.00003 12.9129L1.20435 13.4998Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7957 13.5C17.5615 12.1762 18 10.6394 18 9L0 9C0 10.6394 0.438539 12.1762 1.20431 13.5L16.7957 13.5Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4715_8704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColombia);
export default __webpack_public_path__ + "static/media/icon_colombia.78c9ef235f50bd07845e2569f0344992.svg";
export { ForwardRef as ReactComponent };